// extracted by mini-css-extract-plugin
var _1 = "PricingCheckIcon-module__checkIcon--xtNLM";
export { _1 as "checkIcon" }
